export default {
  title1: {
    en: 'Pick a&nbsp;new&nbsp;scent monthly',
  },
  description1: {
    en: 'Select from 450+&nbsp;designer and&nbsp;niche perfumes',
  },
  title2: {
    en: 'A&nbsp;rollerball size perfume',
  },
  description2: {
    en: 'Get a&nbsp;0.27oz sprayer in&nbsp;a&nbsp;chic metal case, enough to&nbsp;last a&nbsp;month of&nbsp;more than 4x daily sprays',
  },
  title3: {
    en: 'Just $14.95/mo. free shipping',
  },
  description3: {
    en: 'One perfume of&nbsp;your choice is&nbsp;delivered right to&nbsp;your doorstep every month',
  },
  subscribeNow: {
    en: 'Subscribe now',
  },
  back: {
    en: 'Back',
  },
}
